import React from 'react';

/**
 * The brand mark.
 *
 * SVG by default so it stays crisp at the 5rem the login page uses. It is
 * genuine vector (no embedded raster) but ~490 KB of path data, which is a lot
 * for a 28px sidebar mark, so a downscaled PNG ships alongside it at 20 KB.
 * Swapping is this one constant -- if first paint ever looks slow, point it at
 * `/images/mogbots-logo@2x.png` and add the @3x for retina.
 */
const LOGO_SRC = '/images/mogbots-logo.svg';

type LogoProps = {
  /** Height in rem. Width follows the artwork's own aspect ratio. */
  size?: number;
  className?: string;
};

export const Logo = ({ size = 3, className }: LogoProps) => (
  // No heading tag here. Every page renders its own <h1>, and a second one in
  // persistent chrome would compete for the document's top-level heading on
  // every screen at once.
  <span
    className={`logo inline-flex items-center${className ? ` ${className}` : ''}`}
    style={{ height: `${size}rem` }}
  >
    <img
      src={LOGO_SRC}
      alt="MogBots"
      className="h-full w-auto object-contain"
      /* Decorative chrome, never the reason a page is waiting to render. */
      decoding="async"
    />
  </span>
);
